<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-28                                                         -
  ----------------------------------------------------------------------------->

<template>
  <product-category-products v-if="categoryAssignment.ui_template === CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CLASSIC.value"
                             :show-inventory="false"
                             :template-id="categoryAssignment.cfg_template_id"
                             summary-price-name="esup"
                             :dialog-prices-list="[{key:'esup',label:'MSRP'}]"
                             :dialog-attributes-list="[]"
                             :is-public="isPublic" >
  </product-category-products>
  <product-category-products v-else-if="categoryAssignment.ui_template === CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CLASSIC_WITH_STOCK.value"
                             :show-inventory="true"
                             :template-id="categoryAssignment.cfg_template_id"
                             summary-price-name="esup"
                             :dialog-prices-list="[{key:'esup',label:'MSRP'}]"
                             :dialog-attributes-list="[{key: 'product_inventory', label: 'Quantity Available'}]"
                             :is-public="isPublic" >
  </product-category-products>
  <product-category-assignment-non-bto-cards v-else-if="categoryAssignment.ui_template === CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CARDS.value"
                                             :template-id="categoryAssignment.cfg_template_id"
                                             :is-public="isPublic"></product-category-assignment-non-bto-cards>
  <div v-else>This should not display</div>

</template>

<script>
import ProductCategoryProducts from "@/components/dynabook_shared/product-category-products.vue";
import {CATEGORY_ASSIGNMENT_UI_TEMPLATES} from "@/enums/category-assignment-ui-templates";
import YesNo from "@/enums/yes-no";
import ProductCategoryAssignmentNonBtoCards
  from "@/components/dynabook_shared/product-category-assignment-non-bto-cards.vue";

export default {
  name: "product-category-assignment",
  computed: {
    YesNo() {
      return YesNo
    }
  },
  components: {ProductCategoryAssignmentNonBtoCards, ProductCategoryProducts},
  props: {
    categoryAssignment: {
      type: Object,
      required: true
    },
    isPublic:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      CATEGORY_ASSIGNMENT_UI_TEMPLATES: CATEGORY_ASSIGNMENT_UI_TEMPLATES,
    };
  },
}
</script>

<style scoped>

</style>
